/**
 * SuffixDecoder — "Reading the grade name" block.
 * Shared by chapters 2726, 2727, 2728 (Figma RenderSuffixDecoder): a cyan
 * left-accented callout with a bold title + explanatory body paragraph.
 */

import type { SuffixDecoder as SuffixDecoderData } from "../chapter.types";
import "./SuffixDecoder.css";

interface SuffixDecoderProps {
  decoder: SuffixDecoderData;
}

export const SuffixDecoder = ({ decoder }: SuffixDecoderProps) => (
  <section className="suffix-decoder" aria-label={decoder.title}>
    <p className="suffix-decoder__title">{decoder.title}</p>
    <p className="suffix-decoder__text">{decoder.text}</p>
  </section>
);
